import styled from "@emotion/styled";
import { Draggable } from "@hello-pangea/dnd";
import type { DraggableProvided, DraggableStateSnapshot } from "@hello-pangea/dnd";
import { InheritanceStatus, QuestInterface } from "@swivl-mono/types";
import { HRDivider } from "@swivl-mono/ui";
import React, { Component, ReactElement } from "react";

import { Member } from "../../../../Models/Member/Member.Current";
import { WorkflowsJourney } from "../../../../Models/Quests/Quests.Model";
// import type { Quote } from './DataAndHelpers/types';

import BoardQuestList from "../Quests/BoardQuestList";
import BoardQuestListStatic from "../Quests/BoardQuestListStatic";
import AddQuestButtons from "./Components/AddQuestButtons";
import JourneyHeader from "./Components/JourneyHeader";
import "./JourneyColumn.scss";

// const colors = {
//     G50: '#E2E8F0',
//     N30: '#EBECF0',
// }
interface ContainerProps {
  isDragging: boolean;
}
const colors = {
  Background: "#F6F2EF",
  ColumnHover: "#E9E9E9",
  ColumnDragging: "#E9E3DF"
};
export const getBackgroundColor = (isDragging: boolean): string => {
  if (isDragging) {
    return colors.ColumnDragging;
  }

  return "transparent";
};
const Container = styled.div<ContainerProps>`
  background-color: ${(props) => getBackgroundColor(props.isDragging)};
  &:hover {
    background-color: ${colors.ColumnHover};
  }
`;

// interface HeaderProps {
//   isDragging: boolean;
// }

// const Header = styled.div<HeaderProps>`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-top-left-radius: ${borderRadius}px;
//   border-top-right-radius: ${borderRadius}px;
//   background-color: ${({ isDragging }) =>
//     isDragging ? colors.ColumnDragging : colors.Background};
//   transition: background-color 0.2s ease;

//   &:hover {
//     background-color: ${colors.ColumnHover};
//   }
// `;

interface Props {
  title: string;
  workflowJourney: WorkflowsJourney;
  index: number;
  isScrollable?: boolean;
  isCombineEnabled?: boolean;
  isDraggingAQuest?: boolean;
  canEdit: boolean;
  // useClone?: boolean;
}

export default class JourneyColumn extends Component<Props> {
  render(): ReactElement {
    const title: string = this.props.title;
    const workflowJourney = this.props.workflowJourney;
    const quests: QuestInterface[] = this.props.workflowJourney.quests;
    const index: number = this.props.index;

    let dragableQuests: any = [];
    let parentQuests: any = [];

    if (Member.isInChildOrg) {
      quests.forEach((quest: QuestInterface) => {
        if (quest.inheritance === InheritanceStatus.NONE) {
          dragableQuests.push(quest);
        } else {
          parentQuests.push(quest);
        }
      });
    } else {
      dragableQuests = quests;
    }

    const isDragDisabled =
      !this.props.canEdit || workflowJourney.isUnassignedGroup || workflowJourney.journey?.inheritance === InheritanceStatus.IS_PARENT;
    return (
      <Draggable draggableId={title} index={index} isDragDisabled={isDragDisabled}>
        {(provided: DraggableProvided, snapshot: DraggableStateSnapshot) => (
          <Container className="JourneyColumn" ref={provided.innerRef} {...provided.draggableProps} isDragging={snapshot.isDragging}>
            <JourneyHeader
              workflowJourney={this.props.workflowJourney}
              isDragging={snapshot.isDragging}
              dragHandleProps={provided.dragHandleProps}
              isDragDisabled={Boolean(isDragDisabled)}
            />

            {/* <Header isDragging={snapshot.isDragging}>
              <h2
                {...provided.dragHandleProps}
                aria-label={`${title} quote list`}
              >
                {title}
              </h2>
            </Header> */}

            <BoardQuestList
              listId={index.toString()}
              listType="QUEST"
              style={{
                backgroundColor: snapshot.isDragging ? colors.ColumnDragging : undefined
              }}
              quests={dragableQuests}
              // internalScroll={this.props.isScrollable}
              isCombineEnabled={Boolean(this.props.isCombineEnabled)}
              // useClone={Boolean(this.props.useClone)}

              isDraggingAQuest={Boolean(this.props.isDraggingAQuest)}
              canEdit={this.props.canEdit}
            />
            {dragableQuests.length > 0 && parentQuests.length > 0 ? <HRDivider title="PARENT QUESTS" /> : null}

            {parentQuests.length > 0 ? <BoardQuestListStatic quests={parentQuests} /> : null}
            {workflowJourney.isUnassignedGroup ? null : <AddQuestButtons workflowJourney={this.props.workflowJourney} />}
          </Container>
        )}
      </Draggable>
    );
  }
}
